import _ from "lodash";

export const selectModulesWithTopics = (state) => {
  let modules = Object.values(state.modules).filter((m) =>
    m.pmApproach.includes(state.progress.section)
  );
  modules = _.orderBy(modules, "data.order", "asc");
  modules = modules.map((module) => {
    const topics = _.orderBy(
      _.filter(state.topics, { parentContentId: module.contentKey }),
      "data.order",
      "asc"
    );

    return {
      ...module,
      topics,
    };
  });

  return modules;
};

export const selectKeyTerms = (state) =>
  _.orderBy(
    _.filter(state.keyTerms, (i) =>
      i.pmApproach.includes(state.progress.section)
    ).map((i) => ({ ...i, finalTitle: i.data.title || i.title })),
    "finalTitle",
    "asc"
  );

export const selectModuleAndTopicForActivity = (state, activityKey) => {
  const topic = _.find(
    state.topics,
    (t) => t.data.activity.activityKey === activityKey
  );
  if (topic) {
    const mod = state.modules[topic.parentContentId];
    return { topic, module: mod };
  }
  return false;
};

export const selectNextTopic = (state, currentTopic) => {
  const allModulesWithTopics = selectModulesWithTopics(state);
  const currentModuleIndex = _.findIndex(allModulesWithTopics, {
    contentKey: currentTopic.parentContentId,
  });
  const currentModule = allModulesWithTopics[currentModuleIndex];
  if (!currentModule) return allModulesWithTopics[0].topics[0];

  const topicIndex = _.findIndex(currentModule.topics, {
    contentKey: currentTopic.contentKey,
  });
  const isLastTopic = topicIndex + 1 === currentModule.topics.length;
  const isLastModule = currentModuleIndex + 1 === allModulesWithTopics.length;

  if (isLastModule && isLastTopic) return false;
  if (isLastTopic) {
    return allModulesWithTopics[currentModuleIndex + 1].topics[0];
  } else {
    return currentModule.topics[topicIndex + 1];
  }
};

export const selectModulesWithTopicsAndActivities = (state) => {
  const allModules = selectModulesWithTopics(state);
  let result = [];
  _.filter(
    allModules,
    (i) => i.title !== "Introduction" && i.title !== "Agile Introduction Module"
  ).forEach((section) => {
    let hasActivity = false;
    let topics = [];
    section.topics.forEach((topic) => {
      if (topic.data.activity.hasActivity || topic.data.template.hasTemplate) {
        hasActivity = true;
        topics.push(topic);
      }
    });

    if (hasActivity) {
      result.push({ ...section, topics });
    }
  });

  return result;
};

export const selectIsAuthenticated = (state) => {
  return !!state.user.token;
};

export const selectIsTopicFinished = (state, topicId) => {
  return state.progress.finishedTopics.includes(topicId);
};

export const selectProgressPercentage = (state) => {
  return selectProgressPercentageForSection(state, state.progress.section);
};

export const selectProgressPercentageForSection = (state, section) => {
  const finishedTopics = state.progress.finishedTopics;
  const sectionTopicContentKeys = Object.values(state.topics)
    .filter(
      (i) =>
        i.pmApproach.includes(section) && !i.contentKey.includes("introduction")
    )
    .map((i) => i.contentKey);
  const finishedTopicsInSection = _.intersection(
    sectionTopicContentKeys,
    finishedTopics
  ).length;
  return Math.floor(
    (finishedTopicsInSection * 100) / sectionTopicContentKeys.length
  );
};

export const selectBadgeImages = (state) => {
  return state.languages[state.ui.lang].badges;
};

export const selectIsSectionFinished = (state, section) => {
  const finishedTopics = state.progress.finishedTopics;
  const sectionTopics = _.filter(state.topics, (x) =>
    x.pmApproach.includes(section)
  )
    .map((x) => x.contentKey)
    .filter((x) => !x.includes("introduction"));
  if (sectionTopics.length === 0) return false;
  return (
    _.intersection(sectionTopics, finishedTopics).length ===
    sectionTopics.length
  );
};

export const selectSweepstakes = (state) => {
  return JSON.parse(state.config.sweepstakes);
};

export const selectSweepstakeById = (state) => {
  if (!state.config.sweepstakes || state.config.sweepstakes === "[]") return [];
  return state.config.sweepstakes.find(
    (x) => x.id === state.ui.showSweepstakesModal
  );
};
